import { LevelDefinitionScreen } from "./level-definition.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";
import { LevelDefinitionEditRoutes } from "../level-definition-edit";

export const LevelDefinitionRoutes: RouteDefinition[] = [
	{
		path: Paths.levelDefinition.path,
		element: <LevelDefinitionScreen />,
		requiredPermissions: ["UserInAccountPermission_LevelDefinitionAdmin_Read"],
	},
	...LevelDefinitionEditRoutes,
];
